import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterestComponent } from './interest.component';
import { InterestRoutingModule } from './interest-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { TariffsSharedModule } from '../@shared/tariffs.shared.module';

@NgModule({
  declarations: [InterestComponent],
  imports: [CommonModule, MaterialModule, TranslateModule, InterestRoutingModule, TariffsSharedModule],
})
export class InterestModule {}
